import { gql } from "@apollo/client";

export const createGridFilterMutation = gql`
  mutation createGridFilters($input: CreateGridFiltersInput!) {
    createGridFilters(input: $input) {
      id
      userId
      companyId
      gridName
      filterKey
      filterName
      columns
      dataState
    }
  }
`;

export const updateGridFilterMutation = gql`
  mutation updateGridFilters($input: CreateGridFiltersInput!) {
    updateGridFilters(input: $input) {
      id
      userId
      companyId
      gridName
      filterKey
      filterName
      columns
      dataState
    }
  }
`;

export const deleteGridFilterMutation = gql`
  mutation deleteGridFilters($input: DeleteGridFiltersInput!) {
    deleteGridFilters(input: $input) {
      id
    }
  }
`;
